/* @flow */

import React from 'react';
import { Message, Icon } from 'semantic-ui-react';

const NoThread = () => (
  <Message icon>
    <Icon name="send" />
    <Message.Content>
      <Message.Header>Aucune conversation</Message.Header>
    </Message.Content>
  </Message>
);

export default NoThread;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/threads/NoThread.js